<template>
  <div class="home-page d-flex min-vh-100">
    <CContainer fluid>
      <CRow>
        <CCol>
          <CHeader
            fixed
            with-subheader
            light
            class="header-nav"
          >
            <CHeaderBrand
              class="mx-auto site_logo"
              to="/"
            >
              <img
                src="@/assets/icons/logoLR_yoko.svg"
                height="48"
                class="img-fluid"
                alt="Liberty"
              />
            </CHeaderBrand>
          </CHeader>
        </CCol>
      </CRow>

      <CRow
        class="cover_section justify-content-center"
        :style="{
          'background-image':
            'url(' + require('../assets/images/kunozan.jpg') + ')',
        }"
      >
        <CCol
          sm="11"
          lg="9"
        >
          <CRow>
            <CCol
              sm="6"
              lg="8"
              class="mt-5"
            >
              <h2 class="site-title-section mb-4">
                <span>Welcome to</span>LIBERTY RESORT
              </h2>
              <CButton
                color="light"
                size="lg"
                class="px-5 mb-5"
                @click="$router.push('dashboard')"
              >ログイン <i class="icon cil-arrow-right"></i>
              </CButton>
              <h4 class="text-white mb-3">以下のSNSからログインできます</h4>
              <CRow class="social_link">
                <CCol>
                  <a @click="$router.push('dashboard')">
                    <img
                      src="@/assets/images/social_links/facebook.png"
                      alt="Facebook"
                    />
                  </a>
                </CCol>
                <CCol>
                  <a @click="$router.push('dashboard')">
                    <img
                      src="@/assets/images/social_links/line.png"
                      alt="Line"
                    />
                  </a>
                </CCol>
                <CCol>
                  <a @click="$router.push('dashboard')">
                    <img
                      src="@/assets/images/social_links/twitter.png"
                      alt="Twitter"
                    />
                  </a>
                </CCol>
                <CCol>
                  <a @click="$router.push('dashboard')">
                    <img
                      src="@/assets/images/social_links/apple.png"
                      alt="apple"
                    />
                  </a>
                </CCol>
              </CRow>
              <div class="d-sm-down-none">
                <h4 class="text-white pt-3 my-3">
                  会員カードをお持ちの会員様は、以下から会員情報登録を行えます
                </h4>
                <CButton
                  color="light"
                  size="lg"
                  class="px-5"
                  @click="$router.push('add-email')"
                >ログイン用のメール登録 <i class="icon cil-arrow-right"></i>
                </CButton>
              </div>
            </CCol>
            <CCol
              sm="6"
              lg="4"
              class="registration_section my-5"
            >
              <CCard class="m-0 mb-0 mt-5">
                <CCardBody class="p-4">
                  <CForm class="home-form">
                    <h2 class="mb-2">会員登録</h2>
                    <p class="text-white mb-3">
                      「<b class="text-danger">*</b>」がついた項目は必須項目となります。
                    </p>

                    <CInput
                      class="required-mark"
                      prepend="氏"
                      v-model="itemToEdit.familyName"
                    >
                    </CInput>
                    <span
                      class="input-info"
                      v-if="
                        $v.itemToEdit.familyName.$dirty &&
                        !$v.itemToEdit.familyName.required
                      "
                    >
                      氏の入力は必須です
                    </span>

                    <CInput
                      prepend="名"
                      class="required-mark"
                      v-model="itemToEdit.givenName"
                    >
                    </CInput>

                    <span
                      class="input-info"
                      v-if="
                        $v.itemToEdit.givenName.$dirty &&
                        !$v.itemToEdit.givenName.required
                      "
                    >
                      名の入力は必須です
                    </span>

                    <CInput
                      placeholder="生年月日"
                      v-model="itemToEdit.birth"
                      type="date"
                    >
                      <template #prepend-content>
                        <!-- <CIcon name="cil-calendar" /> -->
                        生年月日
                      </template>
                    </CInput>
                    <details class="d-md-none details_summary">
                      <summary>iOS14の生年月日入力について(説明を表示)</summary>
                      <ol>
                        <li>生年月日をタップし、カレンダーを表示</li>
                        <li>左上の年月(例:2020年11月)をタップ</li>
                        <li>年月を選択する</li>
                        <li>左上の年月をタップして日付選択に戻る</li>
                        <li>日付を選択する</li>
                        <li>OKをタップ</li>
                      </ol>
                    </details>
                    <CInput
                      class="required-mark"
                      placeholder="電話番号"
                      prepend="☏"
                      type="number"
                      v-model="itemToEdit.mobile"
                    >
                      <!-- ✆ -->
                    </CInput>
                    <div
                      class="input-info"
                      v-if="
                        $v.itemToEdit.mobile.$dirty &&
                        !$v.itemToEdit.mobile.required
                      "
                    >
                      電話番号の入力は必須です
                    </div>
                    <div
                      class="input-info"
                      v-if="!$v.itemToEdit.mobile.numeric"
                    >
                      電話番号は数値を入力してください
                    </div>
                    <div
                      class="input-info"
                      v-if="!$v.itemToEdit.mobile.maxLength"
                    >
                      電話番号は{{
                        limited.mobile.maxLength
                      }}文字以下で入力してください
                    </div>
                    <div class="home-checkbok">
                      <label>
                        <input
                          type="checkbox"
                          v-model="selectUser"
                          @click="switchField()"
                        />
                        メールアドレスをお持ちでない方</label>
                    </div>
                    <transition name="fade">
                      <div v-if="!selectUser">
                        <CInput
                          class="required-mark"
                          placeholder="Eメール"
                          prepend="@"
                          v-model="itemToEdit.email"
                        />
                        <span
                          class="input-info"
                          v-if="
                            $v.itemToEdit.email.$dirty &&
                            !$v.itemToEdit.email.required
                          "
                        >
                          メールの入力は必須です
                        </span>
                        <span
                          class="input-info text-danger"
                          v-if="
                            $v.itemToEdit.email.$dirty &&
                            !$v.itemToEdit.email.alphaEmailValidator
                          "
                        >
                          メールの形式が正しくありません。
                        </span>
                      </div>

                      <div v-else>
                        <div>
                          <CInput
                            class="required-mark"
                            placeholder="ユーザー名"
                            v-model="itemToEdit.userName"
                          >
                            <template #prepend-content>
                              <CIcon name="cil-user" />
                            </template>
                          </CInput>
                        </div>
                        <div
                          class="text-warning input-info user-sms"
                          v-if="selectUser"
                        >
                          ▲
                          ログイン用のユーザー名は、初期値が電話番号になります
                        </div>
                        <div
                          class="input-info"
                          v-if="
                            $v.itemToEdit.userName.$dirty &&
                            !$v.itemToEdit.userName.required
                          "
                        >
                          ユーザー名の入力は必須です
                        </div>
                        <div
                          class="input-info"
                          v-if="
                            $v.itemToEdit.userName.$dirty &&
                            !$v.itemToEdit.userName.alphaNumValidator
                          "
                        >
                          <span> 使用可能：英数字および記号(@+-_) <br /> </span>
                        </div>
                      </div>
                    </transition>

                    <CInput
                      placeholder="パスワード"
                      type="password"
                      class="required-mark"
                      v-model="itemToEdit.password"
                    >
                      <template #prepend-content>
                        <CIcon name="cil-lock-locked" />
                      </template>
                    </CInput>
                    <div
                      class="input-info"
                      v-if="
                        $v.itemToEdit.password.$dirty &&
                        !$v.itemToEdit.password.required
                      "
                    >
                      パスワードの入力は必須です
                    </div>
                    <div
                      class="input-info"
                      v-if="
                        $v.itemToEdit.password.$dirty &&
                        !$v.itemToEdit.password.minLength
                      "
                    >
                      パスワード制約：8文字以上
                    </div>
                    <div
                      class="password-msg input-info"
                      v-if="
                        $v.itemToEdit.password.$dirty &&
                        !$v.itemToEdit.password.alphaNumAndDotValidator
                      "
                    >
                      <span>
                        使用可能：英数字および記号(!@#$%.?+-) <br />
                      </span>
                    </div>

                    <CInput
                      placeholder="もう一度パスワードを入力してください"
                      type="password"
                      class="mb-4 required-mark"
                      v-model="itemToEdit.repeatPassword"
                    >
                      <template #prepend-content>
                        <CIcon name="cil-lock-locked" />
                      </template>
                    </CInput>

                    <div
                      class="input-info"
                      v-if="
                        $v.itemToEdit.repeatPassword.$dirty &&
                        !$v.itemToEdit.repeatPassword.sameAsPassword
                      "
                    >
                      もう一度パスワードを入力してください
                    </div>
                    <div class="password-msg input-info">
                      <span>
                        パスワード制約：8文字以上<br />
                        使用可能：英数字および記号(!@#$%.?+-) <br />
                        例：Kunozan@2020
                      </span>
                    </div>
                    <!-- .check-terms  -->
                    <CButton
                      @click="
                        $v.itemToEdit.$invalid ? requiredFd() : CheckForm()
                      "
                      color="success"
                      class="ml-0 px-5"
                      block
                      :class="$v.itemToEdit.$invalid ? 'inactive' : 'active'"
                    >登録</CButton>
                  </CForm>
                </CCardBody>
                <!-- <CCardFooter class="p-4"> </CCardFooter> -->
              </CCard>
              <div class="d-md-none">
                <h5 class="text-white pt-3 my-3">
                  会員カードをお持ちの会員様は、以下から会員情報登録を行えます
                </h5>
                <CButton
                  color="light"
                  size="lg"
                  class="px-5 m-auto d-table"
                  @click="$router.push('add-email')"
                >ログイン用のメール登録 <i class="icon cil-arrow-right"></i>
                </CButton>
              </div>
            </CCol>
          </CRow>
          <!-- <CRow class="d-md-none mb-4">
            <CCol>
              <WeatherApp Glocation="shizuoka" />
            </CCol>
            <CCol>
              <WeatherApp Glocation="kawazu" />
            </CCol>
          </CRow> -->
        </CCol>
      </CRow>
      <CRow class="footer">
        <CCol>
          <!-- <CRow class="justify-content-center py-5">
            <CCol class="app_section">
              <CRow class="justify-content-center mb-5 mt-0">
                <CCol>
                  <h2 class="app-title">リバティーリゾート会員アプリ</h2>
                  
                </CCol>
              </CRow>
              <CRow class="install_app">
                <CCol md="6">
                  <h5 class="appstore">
                    <a
                      target="_blank"
                      href="https://play.google.com/store/apps/details?id=jp.liberty.android.libertymember"
                    ><img
                        src="@/assets/icons/playstore.png"
                        alt="Playstore"
                      /></a>
                  </h5>
                  <div class="qr_code d-sm-down-none">
                    <a
                      target="_blank"
                      href="https://play.google.com/store/apps/details?id=jp.liberty.android.libertymember"
                    ><img
                        src="@/assets/images/app/android-qr-code.svg"
                        alt="qr code"
                      /></a>
                  </div>
                </CCol>
                <CCol md="6">
                  <h5 class="appstore">
                    <a
                      href="https://apps.apple.com/us/app/liberty-resort-membership/id1543151490"
                      target="_blank"
                    >
                      <img
                        src="@/assets/icons/applestore.png"
                        alt="Playstore"
                      /></a>
                  </h5>
                  <div class="qr_code d-sm-down-none">
                    <a
                      href="https://apps.apple.com/us/app/liberty-resort-membership/id1543151490"
                      target="_blank"
                    >
                      <img
                        src="@/assets/images/app/ios-qr-code.svg"
                        alt="qr code"
                      />
                    </a>
                  </div>
                </CCol>
              </CRow>
            </CCol>
          </CRow> -->
          <CRow>
            <CCol>
              <TheFooter />
            </CCol>
          </CRow>
        </CCol>
      </CRow>
    </CContainer>

    <CModal
      :show.sync="editingModal"
      :closeOnBackdrop="false"
      :centered="true"
      color="dark"
      size="lg"
    >
      <template #header>
        <h6 class="modal-title">会員登録確認</h6>
      </template>
      <div class="check_form">
        <CRow>
          <CCol
            sm="2"
            class="label"
          >氏名</CCol>
          <CCol sm="4">{{ itemToEdit.familyName }} {{ itemToEdit.givenName }}</CCol>
        </CRow>
        <CRow v-if="itemToEdit.birth">
          <CCol
            sm="2"
            class="label"
          >生年月日</CCol>
          <!-- <CCol sm="4">{{ itemToEdit.birth }}</CCol> -->
          <CCol sm="4">{{ formatBirth() }}</CCol>
        </CRow>
        <CRow>
          <CCol
            sm="2"
            class="label"
          >電話番号</CCol>
          <CCol sm="4">{{ itemToEdit.mobile }}</CCol>
        </CRow>
        <CRow v-if="!selectUser">
          <CCol
            sm="2"
            class="label"
          >メール</CCol>
          <CCol sm="4">{{ itemToEdit.email }}</CCol>
        </CRow>
        <CRow v-else>
          <CCol
            sm="2"
            class="label"
          >ユーザー名</CCol>
          <CCol sm="4">{{ itemToEdit.userName }}</CCol>
        </CRow>
        <CRow>
          <CCol
            sm="2"
            class="label"
          >パスワード</CCol>
          <CCol sm="4">********</CCol>
        </CRow>
        <CRow>
          <CCol>
            <div class="check_terms mt-2">
              <PrivacyPolicy />
              <div class="check-above">
                <label class="check-inline">
                  <input
                    type="checkbox"
                    v-model="checkTerms"
                  />
                  <span>ご利用規約に同意する</span></label>
                <p>
                  入力内容のご確認および同意へのチェック後、「登録」ボタンを押下してください。<br />
                  【ご注意】no-reply@liberty-resort.net
                  からメールが届きますので、迷惑メールフィルタから除外してください。
                </p>
              </div>
            </div>
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <CButton
          @click="editingModal = false"
          color="secondary"
        ><i class="icon cil-x"></i> キャンセル</CButton>
        <CButton
          @click="saveProfile()"
          color="success"
          :disabled="!checkTerms"
        ><i class="icon cil-user-follow"></i> 登録</CButton>
      </template>
    </CModal>
    <CModal
      color="success"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="completedModal"
    >
      <p>
        登録完了しました。<br />
        入力していただいたEメールアドレス宛に確認メールを送信しました。<br />
        迷惑メールの受信拒否設定により弊社からの返信が届かない場合があります。
      </p>
      <template #header> 登録完了 </template>
      <template #footer>
        <CButton
          @click="
            completedModal = false;
            resetData();
          "
          color="danger"
        ><i class="icon cil-x"></i> 閉じる</CButton>
      </template>
    </CModal>
    <CModal
      color="danger"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="errorDialog"
    >
      {{ errors }}
      <template #header> 会員登録失敗 </template>
      <template #footer>
        <CButton
          @click="errorDialog = false"
          color="danger"
        ><i class="icon cil-x"></i> 閉じる</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
// import Vue from "vue";
// Vue.use(window.vuelidate.default);

import axios from "axios";
// import WeatherApp from "../components/WeatherApp";
// var validationMixin = window.vuelidate.validationMixin;
// import DateDropdown from "vue-date-dropdown";

import {
  required,
  numeric,
  minLength,
  maxLength,
  sameAs,
  helpers,
} from "vuelidate/lib/validators";
import historykana from "historykana";
import * as wanakana from "wanakana";
import TheFooter from "@/containers/TheFooter";
const alphaEmailValidator = helpers.regex(
  "alphaEmail",
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);
const alphaNumAndDotValidator = helpers.regex(
  "alphaNumAndDot",
  /^[A-Za-z0-9!@#$%.?+-]*$/
);
const alphaNumValidator = helpers.regex(
  "usernameValidator",
  /^[A-Za-z0-9@._-]*$/
);

export default {
  name: "HomePage",
  components: {
    // WeatherApp,
    TheFooter,
    // DateDropdown,
  },
  data() {
    return {
      confirmModal: false,
      editingModal: false,
      completedModal: false,
      errorDialog: false,
      selectUser: false,
      selectCard: false,
      checkTerms: false,
      allGroups: [],
      UserGroup: "",
      errors: "",
      // defDate: "",
      itemToEdit: {
        // cardId: "",
        email: "",
        familyName: "",
        givenName: "",
        // firstName: "",
        // lastName: "",
        birth: "",
        mobile: "",
        userName: "",
        password: "",
      },
      history: [],
      GUserId: "",
    };
  },
  // mixins: [validationMixin],
  validations() {
    let Gemail;
    let GuserName;
    if (!this.selectUser) {
      Gemail = { required, alphaEmailValidator };
      GuserName = { maxLength: maxLength(100), alphaNumValidator };
    } else {
      Gemail = { maxLength: maxLength(100) };
      GuserName = { required, alphaNumValidator };
    }
    return {
      itemToEdit: {
        familyName: { required, maxLength: maxLength(100) },
        // firstName: { required, maxLength: maxLength(100) },
        givenName: { required, maxLength: maxLength(100) },
        // lastName: { required, maxLength: maxLength(100) },
        // cardId: { numeric, minLength: minLength(16) },
        mobile: {
          required,
          numeric,
          maxLength: maxLength(20),
        },
        email: Gemail,
        userName: GuserName,
        password: {
          required,
          minLength: minLength(8),
          alphaNumAndDotValidator,
        },
        repeatPassword: {
          sameAsPassword: sameAs("password"),
        },
      },
    };
  },

  methods: {
    switchField() {
      this.itemToEdit.userName = this.itemToEdit.mobile;
      this.selectUser
        ? (this.itemToEdit.userName = "")
        : this.$delete(this.itemToEdit, "email");
    },

    saveProfile: function () {
      // if (!this.selectCard) {
      //   this.$delete(this.itemToEdit, "cardId");
      // }
      if (this.itemToEdit.email) {
        this.GUserId = this.itemToEdit.email;
      } else {
        this.GUserId = this.itemToEdit.userName;
      }

      this.$delete(this.itemToEdit, "repeatPassword");

      var urlRequest;
      urlRequest = "/api/users";
      // console.log("editdata" + JSON.stringify(this.itemToEdit));
      axios
        .post(urlRequest, this.itemToEdit, {
          headers: { "api-token": "Eg=HyTs(;^5%Bv6y" },
        })
        .then((resp) => {
          console.log("User profile updated:" + resp.data);
          this.completedModal = true;
          // this.putNewGroup(this.GUserId);
          // this.editingModal = false;

          // this.confirmModal = false;
        })
        .catch((err) => {
          this.itemToEdit.password = "";
          this.errorDialog = true;
          // err.response.status == 400
          //   ? (this.errors = "このユーザーはすでに存在します")
          //   : (this.errors = err);
          if (err.response.status == 409) {
            this.errors =
              "登録済みのメールアドレスです。別のメールアドレスを指定してください。";
          } else {
            this.errors = "会員登録できませんでした。";
          }
        });
    },
    CheckForm() {
      this.editingModal = true;
    },

    familyName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.itemToEdit.firstName = input.target.value;
      } else {
        this.history.push(input.target.value);
        this.itemToEdit.firstName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
    givenName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.itemToEdit.lastName = input.target.value;
      } else {
        this.history.push(input.target.value);
        this.itemToEdit.lastName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
    goEditPage() {
      this.$router.push({
        name: "会員情報編集",
        params: { userId: this.GUserId, success: true },
      });
    },
    requiredFd() {
      this.$v.itemToEdit.$touch();
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.call(this));
    },

    onCheckResult() {
      return !this.$v.itemToEdit.$invalid;
    },

    formatBirth() {
      return this.itemToEdit.birth.replace(/-/g, "/");
    },
  },
  beforeMount() {
    // this.getAllGroup();
  },
};
</script>

